import { safeDefineElement } from '@/scripts/core/global'
import { MainSearch } from '@/scripts/catalog/main-search'
import { DynamicCollection } from '@/scripts/catalog/dynamic-collection'

safeDefineElement(MainSearch)
safeDefineElement(DynamicCollection)
